<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-input v-model="userId" placeholder="请输入用户ID" style="float: left; width: 200px;"></el-input>
        <el-input v-model="userPhone" placeholder="请输入手机号" style="float: left; width: 200px;"></el-input>
        <el-input v-model="userName" placeholder="请输入用户名" style="float: left; width: 200px;"></el-input>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border>
          <el-table-column
            prop="orderNumber"
            label="订单号"
            width="200">
          </el-table-column>
          <el-table-column
            prop="userId"
            label="用户ID"
            width="100">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="userPhone"
            label="手机号"
            width="150">
          </el-table-column>
          <el-table-column
            prop="goodsUnit"
            label="订单单元数"
            width="120">
          </el-table-column>
          <el-table-column
            prop="surplusUnit"
            label="剩余单元数"
            width="120">
          </el-table-column>
          <el-table-column
            prop="goodsNum"
            label="计次商品总数"
            width="120">
          </el-table-column>
          <el-table-column
            prop="unitNum"
            label="每单元次数"
            width="120">
          </el-table-column>
          <el-table-column
            label="附件"
            width="200">
            <template slot-scope="scope">
              <el-image
                v-for="(img, index) in scope.row.link"
                :key="index"
                :src="img"
                :preview-src-list="scope.row.link"
                style="width: 40px; height: 40px; margin-right: 10px;">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="申请说明"
            width="200">
          </el-table-column>
          <el-table-column
            prop="status"
            label="审核状态"
            width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">待审核</span>
              <span v-if="scope.row.status === 1" style="color: #67C23A;">审核通过</span>
              <span v-if="scope.row.status === 2" style="color: #F56C6C;">审核驳回</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="checkRemark"
            label="审核备注"
            width="200">
          </el-table-column>
          <el-table-column
            prop="checkTime"
            label="审核时间"
            width="200">
          </el-table-column>
          <el-table-column
            prop="insertTime"
            label="提审时间"
            width="200">
          </el-table-column>
          <el-table-column label="操作"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleCheck(scope.row)" v-if="!scope.row.status">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="审核计次商品单元"
        :visible.sync="checkDialogVisible"
        width="30%"
        center
        :append-to-body=true>
        <el-form :label-position="left" label-width="100px" :model="checkData">
          <el-form-item label="审核状态">
            <el-select v-model="checkData.status">
              <el-option
                label="审核通过"
                value="1">
              </el-option>
              <el-option
                label="审核驳回"
                value="2">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核备注">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入审核备注"
              v-model="checkData.checkRemark">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="checkDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="checkSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import { getGoodsUnitList, checkGoodsUnit } from 'api/request'
import { ERR_OK } from 'api/config'
import { Success, Error } from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      token: window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      userId: null,
      userPhone: null,
      userName: null,
      list: [],
      checkDialogVisible: false,
      checkData: {
        id: null,
        status: null,
        checkRemark: ''
      }
    }
  },
  mounted() {
    this._getList()
  },
  methods: {
    pageChange(val) {
      this.pageNum = val
      this._getList()
    },
    _getList() {
      const params = {
        current: this.pageNum,
        size: this.pageSize,
        userId: this.userId,
        userPhone: this.userPhone,
        userName: this.userName,
        left: this.left
      }
      getGoodsUnitList(params).then(res => {
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          this.paginationShow = true
        }
      })
    },
    handleCheck(row) {
      this.checkDialogVisible = true
      this.checkData = {
        id: row.id,
        status: '1',
        checkRemark: ''
      }
    },
    checkSubmit() {
      if (this.checkData.status === '2' && !this.checkData.checkRemark) {
        Error('请填写审核备注')
        return
      }
      checkGoodsUnit(this.checkData).then(res => {
        console.log("res.status ",res.status );
        if (res.status === ERR_OK) {
          Success(this, res);
          this._getList()
        } else {
          Error(this, res);
        }
        this.checkDialogVisible = false;
      })
    }
  }
}
</script>
<style scoped>
.orders .product-img{
  width: 90px;
}

.user{
  z-index: 9;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #F8F8F8;
}
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.userTable{
  padding: 10px;
  position: relative;
}
</style>
<style>
.orders table tr.el-table__row--level-0{
  background-color: #f7e7e7 !important;
}
.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/order/goodUnit.vue